import toast from 'react-hot-toast';

/**
 * Xin mã Authenticator (TOTP) trước thao tác admin nhạy cảm (khoá/xoá user, duyệt bài/creator/donate,
 * tắt bình luận...). Trả về mã 6 số, hoặc null nếu admin huỷ / bỏ trống.
 */
export const promptTotp = (label = 'xác nhận thao tác'): string | null => {
  const code = window.prompt(`Nhập mã Authenticator (6 số) để ${label}:`)?.trim();
  if (!code) {
    toast.error('Cần mã Authenticator 6 số để thực hiện.');
    return null;
  }
  return code;
};

/**
 * Như promptTotp nhưng ném lỗi khi admin huỷ, để gọi ngay trong hàm API (thao tác tiền/cấu hình cần mã ở máy chủ).
 * Trả về `{ totpCode }` để gắn vào `params`; interceptor sẽ chuyển sang header X-Totp-Code.
 */
export const requireTotpParams = (label = 'xác nhận thao tác'): { totpCode: string } => {
  const code = promptTotp(label);
  if (!code) throw new Error('Cần mã Authenticator 6 số để thực hiện.');
  return { totpCode: code };
};

/**
 * Đưa mã Authenticator từ query (`?totpCode=`) sang header `X-Totp-Code` trước khi gửi: đường dẫn bị ghi vào
 * log nginx/gateway, header thì không. Backend đọc header trước, query sau (tương thích ngược).
 * Gọi trong interceptor của API nên mọi chỗ đang truyền `params: { totpCode }` không cần sửa.
 */
export const moveTotpToHeader = <C extends { params?: any; headers?: any }>(config: C): C => {
  const code = config.params?.totpCode;
  if (config.params && 'totpCode' in config.params) {
    const { totpCode: _omit, ...rest } = config.params;
    config.params = rest;
    if (code) config.headers = { ...(config.headers || {}), 'X-Totp-Code': String(code) };
  }
  return config;
};
